/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppConfig } from '../../models/app-config';
import { FileUploadDto } from '../../models/file-upload-dto';

export interface UploadAppConfigLogo$Params {
  body: FileUploadDto;
}

export function uploadAppConfigLogo(
  http: HttpClient,
  rootUrl: string,
  params: UploadAppConfigLogo$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AppConfig>> {
  const rb = new RequestBuilder(rootUrl, uploadAppConfigLogo.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppConfig>;
    })
  );
}

uploadAppConfigLogo.PATH = '/admin/app-configs/logo';
